import { format } from 'date-fns';
import { formatInTimeZone, toZonedTime } from 'date-fns-tz';
import { parseISO } from 'date-fns';

export const DateFormats = {
  dayMonthYear: 'dd-LLL-yyyy',
  dayMonthYearTime: 'yyyy-MM-dd HH:mm:ss',
  iso: "yyyy-MM-dd'T'HH:mm:ss",
};

export const TimeZone = {
  RIGA: 'Europe/Riga',
  UTC: 'UTC',
};

export const formatIsoToDate = (isoString: string): string => {
  if (!isoString) return '-';

  return format(isoString, DateFormats.dayMonthYear);
};

export const formatRigaDateTime = (dateString: string | undefined | null): string => {
  if (!dateString) return '';
  return formatInTimeZone(dateString, TimeZone.RIGA, DateFormats.dayMonthYearTime) + ' Riga';
};

export const formatUtcDateTime = (dateString: string | undefined | null): string => {
  if (!dateString) return '';
  return (
    formatInTimeZone(parseISO(dateString), TimeZone.UTC, DateFormats.dayMonthYearTime) + ' UTC'
  );
};

export const utcStringToLocalDate = (utcString: string): Date => {
  return toZonedTime(utcString, TimeZone.RIGA);
};

export const formatYmd = (d: Date): string => format(d, 'yyyy-MM-dd');
